import { IconProps } from "./icon.props"
import MIcon from "@mui/material/Icon"
import * as React from "react"

export function Icon(props: IconProps) {
  const { icon, ...rest } = props

  return <MIcon {...rest}>{icon}</MIcon>
}
